export default "__VITE_ASSET__Cq$Jue2a__"